import * as ACTIONS from '../actions/constants';


const initialState = {
  baskets: []
};


function baskets(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.UPDATE_BASKETS:
      return { baskets: [...action.payload] };
    case ACTIONS.USER_LOG_IN:
      return initialState;
    case ACTIONS.USER_LOG_OUT:
        return initialState;
    default:
      return state;
  }
}

export default baskets;



// WEBPACK FOOTER //
// ./src/reducers/baskets.js